export const currencyFormater = (num?: number, currency = '€') =>
  `${num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${currency}`;
